import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import StatsCardGroup       from 'components/dashboard/StatsCardGroup';
import CadenceCard          from 'components/dashboard/CadenceCard';
import PeakActivityCard     from 'components/dashboard/PeakActivityCard';
import SequencingTimeline   from 'components/dashboard/SequencingTimeline';
import GenomicSignals       from 'components/dashboard/GenomicSignals';
import RunTypeDistribution  from 'components/dashboard/RunTypeDistribution';
import PathogenIntelligence from 'components/dashboard/PathogenIntelligence';
import DashboardPerfPanel   from 'components/dashboard/DashboardPerfPanel';
import { DiagnosticsProvider } from 'context/DiagnosticsContext';
import diagnosticsEnabled from 'utils/diagnosticsEnabled';
import '../assets/css/Dashboard.css';

const RANGE_OPTIONS = [
  { label: 'Current Month',  value: 'currentMonth'       },
  { label: 'Last 24 Hours',  value: 'lastTwentyFourHours' },
];

function DashboardInner() {
  const history = useHistory();
  const [timeRange, setTimeRange] = useState('currentMonth');
  const [perfOpen, setPerfOpen] = useState(false);

  return (
    <div className="dash-root">
      <div className="dash-main">

        {/* ── HERO ─────────────────────────────────────────────────────────── */}
        <div className="dash-hero">
          <div className="dash-hero-left">
            <h1 className="dash-hero-title">Global Genomic Surveillance Dashboard</h1>
            {/* <p className="dash-hero-subtitle">Bio-surveillance Command Center · Real-time Pathogen Detection</p> */}
          </div>
          <div className="dash-hero-actions">
            <div className="dash-hero-filters">
              {RANGE_OPTIONS.map(f => (
                <button
                  key={f.value}
                  className={`dash-hero-filter-btn ${timeRange === f.value ? 'active' : ''}`}
                  onClick={() => setTimeRange(f.value)}
                >
                  {f.label}
                </button>
              ))}
            </div>
            {diagnosticsEnabled && (
              <button
                className="dash-hero-perf-btn"
                onClick={() => setPerfOpen(true)}
                title="Widget performance panel"
              >
                ⚡ Perf
              </button>
            )}
            <button className="dash-hero-primary-btn" onClick={() => history.push('/pass/linechart')}>
              More Analytics →
            </button>
          </div>
        </div>

        {/* ── KPI ROW — each card fetches independently ────────────────────── */}
        <div className="dash-kpi-row">
          <StatsCardGroup />
          <PeakActivityCard timeRange={timeRange} />
          <CadenceCard />
        </div>

        {/* ── MID GRID ─────────────────────────────────────────────────────── */}
        <div className="dash-mid-grid">
          <SequencingTimeline timeRange={timeRange} />
          <div className="dash-mid-right">
            <GenomicSignals />
            <RunTypeDistribution timeRange={timeRange} />
          </div>
        </div>

        {/* ── PATHOGEN INTELLIGENCE (full width bottom) ─────────────────────── */}
        <PathogenIntelligence />

      </div>

      {diagnosticsEnabled && perfOpen && <DashboardPerfPanel onClose={() => setPerfOpen(false)} />}
    </div>
  );
}

function Dashboard() {
  return (
    <DiagnosticsProvider>
      <DashboardInner />
    </DiagnosticsProvider>
  );
}

export default Dashboard;
